import { render } from "./HorizontalLayout.vue?vue&type=template&id=7663b03c&ts=true"
import script from "./HorizontalLayout.vue?vue&type=script&lang=ts"
export * from "./HorizontalLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__